import http from '../http'

/**
 * 分页条件查询付款记录
 * @param {Object} params - 查询参数
 * @param {String} [params.startDate] - 开始日期（可选，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss）
 * @param {String} [params.endDate] - 结束日期（可选，格式：yyyy-MM-dd 或 yyyy-MM-dd HH:mm:ss）
 * @param {String} [params.paymentMethod] - 付款方式（可选，可选值：CASH、BANK_TRANSFER、MOBILE_PAYMENT、REMITTANCE）
 * @param {Number} [params.settlementId] - 结算单ID（可选，查询与该结算单关联的所有付款记录）
 * @param {Number} [params.creatorId] - 创建人ID（可选）
 * @param {Number} [params.page] - 页码，默认为0
 * @param {Number} [params.size] - 每页数量，默认为10
 * @param {String} [params.sortBy] - 排序字段，默认为id
 * @param {String} [params.sortDir] - 排序方向（asc/desc），默认为desc
 * @returns {Promise} 返回付款记录列表和分页信息
 */
export function query_payments_pagination(params = {}) {
// 转换分页参数
  const queryParams = {
    page: params.page !== undefined ? params.page : (params.current ? params.current - 1 : 0),
    size: params.size || params.pageSize || 10,
    sortBy: params.sortBy || 'id',
    sortDir: params.sortDir || 'desc'
  }
  
  // 添加搜索条件
  if (params.startDate) {
    queryParams.startDate = params.startDate
  }
  if (params.endDate) {
    queryParams.endDate = params.endDate
  }
  if (params.paymentMethod) {
    queryParams.paymentMethod = params.paymentMethod
  }
  if (params.settlementId) {
    queryParams.settlementId = params.settlementId
  }
  if (params.creatorId) {
    queryParams.creatorId = params.creatorId
  }
  
  return http.get('/payments/search', { params: queryParams })
}

/**
 * 根据ID查询付款记录详情
 * @param {number} id - 付款记录ID
 * @returns {Promise} 返回付款记录详情的Promise对象，包括付款基本信息和关联结算单信息
 */
export function query_payment_by_id(id) {
return http.get(`/payments/${id}`)
}

/**
 * 根据结算单ID查询付款记录列表
 * @param {number} settlementId - 结算单ID
 * @returns {Promise} 返回付款记录列表的Promise对象
 */
export function query_payments_by_settlement(settlementId) {
return http.get(`/payments/settlement/${settlementId}`)
}

/**
 * 创建或更新付款记录（智能创建或更新）
 * @param {Object} data - 付款数据
 * @param {Number} [data.id] - 付款记录ID(更新时提供，新增时不提供)
 * @param {String} data.paymentDate - 付款时间（yyyy-MM-dd HH:mm:ss格式），必填
 * @param {Number} data.amount - 付款金额，必填
 * @param {String} data.paymentMethod - 付款方式，必填（CASH、BANK_TRANSFER、MOBILE_PAYMENT、REMITTANCE）
 * @param {Array<Number>} data.settlementIds - 关联的结算单ID列表（支持多个结算单），必填
 * @param {String} [data.voucherUrl] - 付款凭证URL（可选）
 * @param {String} [data.remark] - 备注信息（可选）
 * @returns {Promise} 返回保存结果的Promise对象
 */
export function save_payment(data) {
return http.post('/payments', data)
}

/**
 * 更新付款记录
 * @param {Number} id - 付款记录ID
 * @param {Object} data - 付款数据
 * @returns {Promise} 返回更新结果的Promise对象
 */
export function update_payment(id, data) {
return http.put(`/payments/${id}`, data)
}

/**
 * 删除付款记录（逻辑删除）
 * @param {Number} id - 付款记录ID
 * @returns {Promise} 返回删除结果的Promise对象
 */
export function delete_payment(id) {
return http.delete(`/payments/${id}`)
}

export default {
  query_payments_pagination,
  query_payment_by_id,
  query_payments_by_settlement,
  save_payment,
  update_payment,
  delete_payment
}
